import React, { Component } from "react";
import { Modal, Tooltip } from "antd";
import router from "umi/router";
import { stringify } from "qs";
import { connect } from "dva";
import styles from "./index.less";
import EditModal from "../components/EditModal";
import EditNameModal from "../components/EditNameModal";
import Container from "../../../../../components/Container";
import ListPage from "../../../../../components/ListPage";
import OperateDropdown from "../../../../../components/OperateDropdown";

const { confirm } = Modal;
const { ListTable, ListCreate } = ListPage;

@connect(({ norm }) => ({
  dataList: norm.templateList,
  spinProps: norm.spinProps,
  pageInfo: norm.pageInfo
}))
class ManagementView extends Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        title: "指标模版名称",
        dataIndex: "templateName",
        width: "82%",
        render: templateName => (
          <Tooltip placement="top" title={templateName}>
            <span>
              {templateName?.length <= 50
                ? templateName
                : `${templateName?.substring(0, 50)}...`}
            </span>
          </Tooltip>
        )
      },
      {
        title: "操作",
        width: "18%",
        render: record => {
          const data = [
            {
              text: (
                <a
                  onClick={event =>
                    this.handleRename({ visible: true, record, event })
                  }
                >
                  重命名
                </a>
              )
            },
            {
              text: (
                <a
                  onClick={event =>
                    this.handleCopy({ visible: true, record, event })
                  }
                >
                  复制模版
                </a>
              )
            },
            {
              text: (
                <a onClick={event => this.handleJumpSetting({ record, event })}>
                  指标设置
                </a>
              )
            },
            {
              text: (
                <a onClick={event => this.handleDelete({ record, event })}>
                  删除
                </a>
              )
            }
          ];
          return <OperateDropdown data={data} />;
        }
      }
    ];

    this.state = {
      columns,
      showAddModal: false,
      showRenameModal: false,
      showCopyModal: false,
      isAdd: true,
      renameData: {},
      copyData: {},
      formData: {
        type: "",
        templateName: ""
      }
    };
  }

  componentDidMount() {
    this.handleCallBack();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "norm/reset"
    });
  }

  handleRename = ({ visible = false, record = {}, event } = {}) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      showRenameModal: visible,
      renameData: record
    });
  };

  handleCopy = ({ visible = false, record = {}, event } = {}) => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({
      showCopyModal: visible,
      copyData: record
    });
  };

  handleJumpSetting = ({ record = {}, event } = {}) => {
    if (event) {
      event.stopPropagation();
    }
    const breadString = stringify({
      currentNormName: record.templateName,
      currentNormId: record.id
    });
    router.push(`/supervision/norm/management/settings?${breadString}`);
  };

  // 单个删除
  handleDelete = ({ record, event }) => {
    const { templateName, id } = record;
    if (event) {
      event.stopPropagation();
    }
    const { dispatch } = this.props;

    confirm({
      title: `删除指标模版？`,
      content: `确定删除"${templateName}"指标模版吗？`,
      okText: "确定",
      cancelText: "取消",
      centered: true,
      onOk: () => {
        dispatch({
          type: "norm/fetchDeleteNorm",
          payload: { id },
          callback: this.handleCallBack
        });
      }
    });
  };

  handleShowAddModal = ({
    isAdd,
    formData = { type: "", templateName: "" }
  }) => {
    this.setState({
      isAdd,
      formData,
      showAddModal: true
    });
  };

  handleCloseEditModal = () => {
    this.setState({
      showAddModal: false
    });
  };

  handleAdd = ({ type, name }) => {
    const { dispatch } = this.props;
    dispatch({
      type: "norm/fetchAddNorm",
      payload: {
        templateName: name,
        templateType: type
      },
      callback: this.handleCallBack
    });
    this.setState({
      showAddModal: false
    });
  };

  handleSubmitRename = newData => {
    const { dispatch } = this.props;

    dispatch({
      type: "norm/fetchreNameNorm",
      payload: {
        ...newData
      },
      callback: this.handleCallBack
    });
    this.setState({
      showRenameModal: false
    });
  };

  // 提交复制模板
  handleSubmitCopy = copyData => {
    const { dispatch } = this.props;
    const { id, templateName } = copyData;
    dispatch({
      type: "norm/fetchCopyNorm",
      payload: {
        id,
        templateName
      },
      callback: this.handleCallBack
    });

    this.setState({
      showCopyModal: false
    });
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.handleCallBack(pageInfo);
  };

  handleCallBack = pageInfo => {
    const { dispatch } = this.props;
    dispatch({
      type: "norm/fetchGetNorm",
      payload: {
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  renderRenameModal = () => {
    const { showRenameModal, renameData } = this.state;
    const renameProps = {
      title: "重命名指标模版",
      label: "指标模版名称",
      type: "rename",
      onOk: newData => this.handleSubmitRename(newData),
      onCancel: () => this.setState({ showRenameModal: false }),
      data: renameData
    };
    return showRenameModal && <EditNameModal {...renameProps} />;
  };

  renderCopyModal = () => {
    const { showCopyModal, copyData } = this.state;
    const renameProps = {
      title: "复制指标模版",
      label: "复制指标模版名称",
      type: "copy",
      onOk: newData => this.handleSubmitCopy(newData),
      onCancel: () => this.setState({ showCopyModal: false }),
      data: copyData
    };
    return showCopyModal && <EditNameModal {...renameProps} />;
  };

  renderEditModal = () => {
    const { showAddModal, isAdd, formData } = this.state;
    const editProps = {
      title: isAdd ? "添加指标模版" : "编辑模版",
      onCancel: () => this.setState({ showAddModal: false }),
      onOk: isAdd ? this.handleAdd : this.handleEdit,
      data: formData
    };
    return showAddModal && <EditModal {...editProps} />;
  };

  render() {
    const { spinProps, dataList, pageInfo } = this.props;
    const { columns } = this.state;

    const pageProps = {
      spinProps,
      className: styles.management
    };

    const createBtn = {
      btnText: " 添加模板",
      onCreate: () => this.handleShowAddModal({ isAdd: true })
    };

    const tableProps = {
      columns,
      rowKey: "id",
      list: dataList,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };

    return (
      <Container breStates version={2}>
        <ListPage {...pageProps}>
          <ListCreate {...createBtn} />
          <ListTable {...tableProps} />
          {this.renderEditModal()}
          {this.renderRenameModal()}
          {this.renderCopyModal()}
        </ListPage>
      </Container>
    );
  }
}

export default ManagementView;
